import React from 'react'
import PropTypes from 'prop-types'
import { Button, SearchInput, SortableTable } from 'components/UIElements'
import StickyHeader from '../../../../../components/StickyHeader'
import { calculateOffsets } from '../../../../../utils/misc.js'
import { navigateTo } from 'navigation'
import '../stylesheets/Users.scss'

const HEADER_OPTIONS = [
  { key: 'nickname', sortable: true, component: 'Nickname' },
  { key: 'email', sortable: true, component: 'Email' },
  { key: 'role', sortable: true, component: 'Access Level' },
  { key: 'lastLogin', sortable: true, component: 'Last Login' }
]

class UserPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { offsets: null }
  }

  componentDidMount() {
    this.setState({ offsets: calculateOffsets('sticky') })
  }

  render() {
    const { list, searchTerm } = this.props
    const { offsets } = this.state
    return (
      <div className='users page'>
        <StickyHeader offset={offsets ? offsets[0] : 0}>
          <h2>Users</h2>
          <Button
            content='Create User'
            onClick={() => navigateTo('/users/create')}
          />
        </StickyHeader>
        <StickyHeader offset={offsets ? offsets[1] : 0}>
          <h4>{`All ${list.length} Users`}</h4>
          <SearchInput />
        </StickyHeader>
        <SortableTable
          offset={offsets ? offsets[2] : 0}
          searchTerm={searchTerm}
          searchKeys={['nickname', 'email']}
          onRowClick={rowData => {
            navigateTo(`/users/${rowData[0].id}`)
          }}
          className='user-list'
          sortingBy='nickname'
          rowList={list}
          headerOptions={HEADER_OPTIONS}
        />
      </div>
    )
  }
}

UserPage.propTypes = {
  updateSearchTerm: PropTypes.func,
  searchTerm: PropTypes.string,
  list: PropTypes.array
}

export default UserPage
